"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MessageDispatcher_1 = __importDefault(require("../Messages/MessageDispatcher"));
var NotificationEvent_1 = __importDefault(require("../NotificationEvent/NotificationEvent"));
var NotificationEventType_1 = require("../NotificationEvent/NotificationEventType");
var UrlParser_1 = __importDefault(require("../Utils/UrlParser"));
var AbstractWidget = /** @class */ (function () {
    /**
     * Constructor
     * @param config
     */
    function AbstractWidget(config) {
        this.resizeTimeoutInterval = 0;
        this._config = config;
        this.addNotificationListeners();
    }
    /**
     * Returns Element config
     */
    AbstractWidget.prototype.getConfig = function () {
        return this._config;
    };
    /**
     * Envía al padre las dimensiones actuales
     */
    AbstractWidget.prototype.notifySizeToParent = function () {
        var parentIframeId = new UrlParser_1.default(document.location.href).getParam("id");
        MessageDispatcher_1.default.send(parent, new NotificationEvent_1.default(NotificationEventType_1.NotificationEventType.RESIZE, parentIframeId, {
            height: document.body.clientHeight,
            width: document.body.clientWidth,
        }));
    };
    /**
     * Registra los listeners para notificar cambios al iframe padre
     */
    AbstractWidget.prototype.addNotificationListeners = function () {
        var _this = this;
        var parentIframeId = new UrlParser_1.default(document.location.href).getParam("id");
        window.addEventListener("resize", function () {
            clearInterval(_this.resizeTimeoutInterval);
            _this.resizeTimeoutInterval = setTimeout(function () {
                MessageDispatcher_1.default.send(parent, new NotificationEvent_1.default(NotificationEventType_1.NotificationEventType.RESIZE, parentIframeId, {
                    height: document.body.clientHeight,
                    width: document.body.clientWidth,
                }));
            }, 200);
        });
        /*window.addEventListener(
          "message",
          (event) => {
            const notificationEvent: INotificationEvent = event.data as INotificationEvent;
    
            this.handleMessages(notificationEvent);
          },
          false
        );*/
    };
    /**
     * Maneja el evento
     * @param notificationEvent
     */
    AbstractWidget.prototype.handleMessages = function (notificationEvent) {
        var parentIframeId = new UrlParser_1.default(document.location.href).getParam("id");
        switch (notificationEvent.eventType) {
            case NotificationEventType_1.NotificationEventType.RESIZE: {
                //Solo procesamos mensaje si el target somos nosotros
                if (notificationEvent.targetId == parentIframeId)
                    this.notifySizeToParent();
                break;
            }
            case NotificationEventType_1.NotificationEventType.REDIRECT: {
                document.location.href = notificationEvent.data.url;
                break;
            }
        }
    };
    return AbstractWidget;
}());
exports.default = AbstractWidget;
